import React from 'react';
import { translate, Interpolate } from 'react-i18next';

import Modal from 'components/Modal';

import UserSettingActions from 'actions/UserSettingActions';

class TOSModal extends React.Component {
  constructor(props) {
    super(props);

    this.acceptTOS.bind(this);
    this.signOut.bind(this);
  }

  signOut() {
    Utils.signOut();
  }

  acceptTOS() {
    UserSettingActions.acceptTOS();
  }

  render() {
    let modal = null;

    if (this.props.requiresTOSAcceptance) {
      const header = this.props.t('TOSModal.accept_terms');
      const body = (
        <span>
          <Interpolate 
            i18nKey="TOSModal.accept_and_confirm"
            brandName={window.EmployeeWeb.ENVConfig.brand_name}
            termsLink={
              <a href={window.EmployeeWeb.ENVConfig.terms_link} target="_blank">
                {window.EmployeeWeb.ENVConfig.brand !== 'adp'
                  ? this.props.t('TOSModal.terms_of_service')
                  : this.props.t('TOSModal.terms_and_conditions')
                }
              </a>
            }
            privacyLink={<a href={window.EmployeeWeb.ENVConfig.privacy_link} target="_blank">{this.props.t('TOSModal.privacy_policy')}</a>}
          />
        </span>
      );
      const footer = (
        <div className="btn-group pull--right">
          <button className="button" onClick={this.signOut}>{this.props.t('TOSModal.sign_out')}</button>
          <button className="button button--recommended" onClick={this.acceptTOS}>{this.props.t('TOSModal.i_agree')}</button>
        </div>
      );

      modal = (
        <Modal
          header={header}
          body={body}
          footer={footer}
        />
      );
    }

    return modal;
  }
}

export default translate()(TOSModal);
